export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9621.7630889a.jpg";